// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"273":"8808f89785","938":"f31afb2cd6"}[chunkId] + ".js";
};